import * as React from 'react';

interface IProps {
  children: (
    open: boolean,
    onOpen: () => void,
    onClose: () => void
  ) => React.ReactNode;
}

// Render prop that keeps track of a open state and provides an onClose and an onOpen function
const EDOpen: React.FC<IProps> = ({ children }) => {
  const [open, setOpen] = React.useState(false);

  const onOpen = React.useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const onClose = React.useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return children(open, onOpen, onClose);
};

export default EDOpen;
